import React from 'react';
import './StatCard.css';

const StatCard = ({ title, value, subtitle, icon, trend }) => {
    return (
        <div className="stat-card">
            <div className="stat-card-header">
                <h3 className="stat-card-title">{title}</h3>
                {icon && <div className="stat-card-icon">{icon}</div>}
            </div>
            <div className="stat-card-value">{value}</div>
            {subtitle && <div className="stat-card-subtitle">{subtitle}</div>}
            {trend && (
                <div className={`stat-card-trend ${trend.type}`}>
                    {trend.value}
                </div>
            )}
        </div>
    );
};

export default StatCard;

